import CoachProfileLeadForm from './coach-profile-lead-form'

export default CoachProfileLeadForm
